import React, { useState, useRef } from 'react';
import './Tooltip.css';

const Tooltip = ({ children, text, multiline = false }) => {
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const contentRef = useRef(null);

    const handleMouseEnter = (e) => {
        // Check if text is truncated (ellipsis is showing)
        const element = contentRef.current;
        if (element) {
            const isTruncated = element.scrollWidth > element.clientWidth;
            
            // Only show tooltip if text is actually truncated
            if (isTruncated) {
                const rect = e.currentTarget.getBoundingClientRect();
                setPosition({
                    top: rect.top - 10,
                    left: rect.left + rect.width / 2,
                });
                setVisible(true);
            }
        }
    };

    const handleMouseLeave = () => {
        setVisible(false);
    };

    return (
        <>
            <span 
                ref={contentRef}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className="tooltip-trigger"
            >
                {children}
            </span>
            {visible && (
                <div 
                    className={`custom-tooltip ${multiline ? 'multiline' : ''}`}
                    style={{
                        top: `${position.top}px`,
                        left: `${position.left}px`,
                    }}
                >
                    {text}
                    <div className="tooltip-arrow" />
                </div>
            )}
        </>
    );
};

export default Tooltip;

